import * as SettingActionType from './constants';
const AssigneeNotice = [
  {
    content: '',
    order: 1,
    sendAfter: 0,
    emails: [],
    enable: true
  },
  {
    content: '',
    order: 2,
    sendAfter: 1,
    emails: [],
    enable: false
  },
  {
    content: '',
    order: 3,
    sendAfter: 1,
    emails: [],
    enable: false
  },
  {
    content: '',
    order: 4,
    sendAfter: 1,
    emails: [],
    enable: false
  }
];

const defaultCustomStyle = {
  primaryPalette: '#4267B2',
  secondaryPalette: '#F06424'
};

const SettingState = {
  ProjectOperation: null,
  BuilderConfigs: null,
  NoticeRequest: null,
  AssigneeNotice: AssigneeNotice,
  CustomStyle: defaultCustomStyle,
  CurrentCustomStyle: defaultCustomStyle,
  HOCurrentCustomStyle:defaultCustomStyle,
  HOCustomStyle:defaultCustomStyle,
  TenantProfile: null,
  CustomTermsData: {}
};

export default function SettingStore(state = SettingState, action) {
  switch (action.type) {
    case SettingActionType.GET_SETTING_NOTICE_REQUEST_SUCCESS:
      return {
        ...state,
        NoticeRequest: action.data
      };
    case SettingActionType.UPDATE_SETTING_NOTICE_REQUEST_SUCCESS:
      return {
        ...state,
        NoticeRequest: action.data
      };
    case SettingActionType.GET_SETTING_BUILDER_CONFIGS_SUCCESS:
        return {
          ...state,
          BuilderConfigs: action.data
        };
    case SettingActionType.GET_SETTING_PROJECT_OPERATION_SUCCESS:
      return {
        ...state,
        ProjectOperation: action.data
      };
    case SettingActionType.UPDATE_SETTING_PROJECT_OPERATION_SUCCESS:
      return {
        ...state,
        ProjectOperation: action.data
      };
    case SettingActionType.SETTING_ASSIGNEE_NOTICE_BUILDER_LEVEL_SUCCESS:
      action.data.map(item => {
        item.emails = item.emails ? item.emails.split(',') : [];
      });
      return {
        ...state,
        AssigneeNotice: action.data.sort(compare)
      };
    case SettingActionType.UPDATE_CUSTOM_COLOR_PALETTES_SUCCESS:
      return {
        ...state,
        CustomStyle: action.data
      };
      case SettingActionType.UPDATE_HO_CUSTOM_COLOR_PALETTES_SUCCESS:
        return {
          ...state,
          HOCustomStyle: action.data
        };  
    case SettingActionType.CANCEL_TEMPORARY_COLOR_PICKER:
      return {
        ...state,
        CustomStyle: { ...state.CurrentCustomStyle }
      };
    case SettingActionType.CANCEL_HO_TEMPORARY_COLOR_PICKER:
      return {
        ...state,
        HOCustomStyle: { ...state.HOCurrentCustomStyle }
      };
    case SettingActionType.SET_CURRENT_CUSTOM_COLOR:
      return {
        ...state,
        CurrentCustomStyle: action.data
      };
    case SettingActionType.SET_HO_CURRENT_CUSTOM_COLOR:
      return {
        ...state,
        HOCurrentCustomStyle: action.data
      };
      case SettingActionType.GET_SETTING_BUILDER_CONFIGS_SUCCESS_LOADER:
        return {
          ...state,
          StatusCode: action.statuscode
        };
    case SettingActionType.GET_TENANT_PROFILE_SUCCESS:
      return {
        ...state,
        TenantProfile: action.data
      };
    case SettingActionType.GET_CUSTOM_TERMS_SUCCESS:
      return {
        ...state,
        CustomTermsData: action.data
      };
    default:
      return state;
  }
}

const compare = (a, b) => {
  if (a.order < b.order) {
    return -1;
  }
  if (a.order > b.order) {
    return 1;
  }
  return 0;
};



// WEBPACK FOOTER //
// ./src/Setting/reducers.js